/* DecantGems scent curve: draws the curve once when it scrolls into view. Without this file the curve is simply there. */
(function () {
  var plots = document.querySelectorAll('[data-dgc]');
  if (!plots.length || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* length of a stroke as drawn on screen (the shapes are stretched, the strokes are not) */
  function drawn(path) {
    var m = path.getScreenCTM(), total = path.getTotalLength(), sum = 0, prev, i, p, x, y;
    if (!m) return 0;
    for (i = 0; i <= 60; i++) {
      p = path.getPointAtLength((total * i) / 60);
      x = p.x * m.a + p.y * m.c;
      y = p.x * m.b + p.y * m.d;
      if (i) sum += Math.hypot(x - prev[0], y - prev[1]);
      prev = [x, y];
    }
    return Math.ceil(sum) + 2;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target, lines = el.querySelectorAll('.dgc__line');
      io.unobserve(el);
      lines.forEach(function (line) {
        var n = drawn(line);
        line.style.strokeDasharray = n;
        line.style.strokeDashoffset = n;
      });
      el.getBoundingClientRect();
      el.classList.remove('is-arm');
      el.classList.add('is-in');
      lines.forEach(function (line) { line.style.strokeDashoffset = 0; });
      setTimeout(function () {
        lines.forEach(function (line) { line.style.strokeDasharray = line.style.strokeDashoffset = ''; });
      }, 1400);
    });
  }, { threshold: 0.4 });

  plots.forEach(function (el) {
    if (el.getBoundingClientRect().top < innerHeight) return; /* already in view: leave it as it is, no flash */
    el.classList.add('is-arm');
    io.observe(el);
  });
})();
